import { StrictMode } from 'react'

import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { registerSW } from 'virtual:pwa-register'

import { queryClient } from '@/infra'
import { enableMSW } from '@/infra/msw'
import { router } from 'routes'

import '@/infra/clarity'
import '@/infra/firebase'
import '@/infra/i18n'

import './index.css'

registerSW({
  onRegisteredSW(_, serviceWorkerRegistration) {
    if (!serviceWorkerRegistration) return

    window.addEventListener('focus', () => {
      serviceWorkerRegistration.update()
    })

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        serviceWorkerRegistration.update()
      }
    })
  },
  immediate: true,
})

// NOSONAR
enableMSW().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </StrictMode>,
  )
})
